import React, {useEffect, useState} from "react";
import Button from "@material-ui/core/Button";
// styles
import style from "./JobDetails.module.scss";
import { jobData } from "./jobData";
// components
import {IoIosArrowForward} from "react-icons/io";
import {ScrollToTop, SplitNonEmpty, Metadata} from "../../../../Utilities";
import App from "../../../../App";
import ApplyNowModal from "./component/ApplyNowModal";
import {isNullOrUndefined} from "util";
import {formatDate} from "../../../../data/dateformatting";
import { Link, withRouter } from "react-router-dom";
import Axios from "axios"
import { parse } from "path";
// import { error } from "console";
import "./jobDetail.scss"
import $ from 'jquery';


 const JobDetails = ({ history })=> {

  const [categoryId , setCategoryId] = useState("")
  const [data, setData] = useState([])
  const [searchData, setSearchData]= useState([])

 

  // const newdata = data.toString()
 
  // let str = data
  // let array = newdata.split(" ");
  // array.shift()
  
 
  // console.log("array============", text)
  
  

//   let origString = newitem;
 
//   let stringToAdd = `"`;
//   let indexPosition = 0;
//   // characters
//   origString = origString.split('');
//   origString.splice(indexPosition, 0, stringToAdd);
       
//  let newString = origString.join('');

  // console.log(newval)
  // console.log("**************************************",newd);
 
  // const htmlCode = newitem
 



//   const handleChange=(e)=>{
//     setSearchInput(e.target.value)
//     e.preventDefault();
//     const value = e.target.value
//     // console.log("searchValue-----------", value)
//     let filterdata = [...jobData]
//     if(value.length > 2){
//       filterdata = jobData.filter((item) => {
//         return item?.heading.toLowerCase().includes(value.toLowerCase())
//     })
//     setFilteredResults(filterdata)
//     console.log("filterdata--------------------============", filterdata)
//     }
//     else{
//       setFilteredResults(jobData)
//   }
//   }

//   const handleSearchData = (e) => {
//     e.preventDefault();
//     console.log("searchValue-----------", searchInput)
//     let filterdata = [...jobData]
//     if(searchInput.length > 2){
//       filterdata = jobData.filter((item) => {
//         return item?.heading.toLowerCase().includes(searchInput.toLowerCase())
//     })
//     setFilteredResults(filterdata)
//     console.log("filterdata--------------------============", filterdata)
//     }
//     else{
//       setFilteredResults(jobData)
//   }
// }

// console.log("category id -------------------------------------", categoryId)

// console.log("filteredResults===============", filteredResults)

  // const handleButtonClick = (id) => {
  //   history.push({
  //     pathname: "/jobseeker/findjobs",
  //     search: `?ja-job=${id}`,
  //   });
  // };

  // handleClick = (event) => {
  //   const jobId = event.target.getAttribute('data-job-id');
  //   console.log("=========***********______________________________________",jobId);
  // }

  
  // constructor(props) {
  //   super(props);

  //   this.state = {
  //     id: null,
  //     job: null,
  //     found: true,
  //     applyNowOpen: false,
  //   };
  // }

  // render() {
  //   const job = this.state.job;
  //   const queryParams = new URLSearchParams("?term=pizza&location=Bangalore")
  //   const term = queryParams.get("term")
  //   console.log("term-----------------", term)

  window.location.href.split('#')

  useEffect(()=>{
    getJobData()
    getsearchdata()
  },[])
// https://apps.jobadder.com/widgets/V1/Jobs/RenderJobList?callback=jQuery19108558704436298281_1695040921642&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&jobsPerPage=10&showHotJobsOnly=false&titleIsLink=true&showDatePosted=true&datePostedFormat=%7B0%7D&dateFormat=d%2FM%2Fyyyy&showClassifications=true&classificationsToExclude=&showSalary=false&salaryFormat=%7B0%7D&includeSalaryText=false&showJobReference=false&jobReferenceFormat=%7B0%7D&alwaysShowPager=false&showPagerSummary=true&pagerGroupSize=4&scrollOnPageChange=true&animateScrollOnPageChange=false&readMoreText=More..&noJobsContent=There+are+no+jobs+matching+your+criteria.+Please+try+a+broader+search.&renderPoweredByJobAdder=false&classificationIDs=&keywords=&pageNumber=2&_=1695040921645

  const getsearchdata = async ()=>{
    // https://apps.jobadder.com/widgets/V1/Jobs/RenderSearchForm?callback=jQuery191028931031216352343_1694598571641&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&classificationsToExclude=&showLabels=true&optionText=&showKeywordSearch=true&autoSearch=false&showSearchButton=true&searchButtonText=Search&_=1694598571642
    const response = Axios.get("https://apps.jobadder.com/widgets/V1/Jobs/RenderSearchForm?callback=jQuery191028931031216352343_1694598571641&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&classificationsToExclude=&showLabels=true&optionText=&showKeywordSearch=true&autoSearch=false&showSearchButton=true&searchButtonText=Search&_=1694598571642").then((res)=>{
      // console.log("response--------------", res.data)
      setSearchData(res.data)
    }).catch((error)=>{
      console.log(error)
    })
    return response
  }

  let stext = String(searchData)
  let sarr = stext.split(" ")
  sarr.shift()
  let sitem = sarr.join(" ")
  let snewitem = unescape(JSON.parse(`"${sitem.slice(0, -3)}"`));

  const getJobData = async ()=>{
    const response = Axios.get("https://apps.jobadder.com/widgets/V1/Jobs/RenderJobList?callback=jQuery191019848594342491133_1694523503275&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&jobsPerPage=10&showHotJobsOnly=false&titleIsLink=true&showDatePosted=true&datePostedFormat=%7B0%7D&dateFormat=d%2FM%2Fyyyy&showClassifications=true&classificationsToExclude=&showSalary=false&salaryFormat=%7B0%7D&includeSalaryText=false&showJobReference=false&jobReferenceFormat=%7B0%7D&alwaysShowPager=false&showPagerSummary=true&pagerGroupSize=4&scrollOnPageChange=true&animateScrollOnPageChange=false&readMoreText=More..&noJobsContent=There+are+no+jobs+matching+your+criteria.+Please+try+a+broader+search.&renderPoweredByJobAdder=true&_=1694523503277").then((res)=>{
      // console.log("response--------------", res.data)
      setData(res.data)
    }).catch((error)=>{
      console.log(error)
    })
    return response
  }

  useEffect(() => {
    localStorage.clear()

    $(document.body).on('change', '#ja-def-22984', function() {
     
    let data = $('#ja-def-22984').find(":selected").val()
     localStorage.setItem("categoryId", data)
     setCategoryId(data)
     const response = Axios.get(`https://apps.jobadder.com/widgets/V1/Jobs/GetClassifications?callback=jQuery19104529723816309019_1695009459291&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&parentID=${categoryId}&_=1695009459294`).then((res)=>{
      // console.log("response--------------", res.data)
      
    }).catch((error)=>{
      console.log(error)
    })
      return response
    });

    $(document.body).on('change', '#ja-def-22985', function() {     
      // alert($('#ja-def-22985').find(":selected").val())
      let work = $('#ja-def-22985').find(":selected").val()
       localStorage.setItem("sub-category", work)
  });

    $(document.body).on('change', '#ja-def-22986', function() {     
      // alert($('#ja-def-22986').find(":selected").val())
      let loc = $('#ja-def-22986').find(":selected").val()
       localStorage.setItem("location", loc)
      });

     $(document.body).on('change', '#ja-def-22987', function() {     
        // alert($('#ja-def-22987').find(":selected").val())
        let work = $('#ja-def-22987').find(":selected").val()
         localStorage.setItem("work-type", work)
    });

    // ja-def-22985
    
   
    $(document.body).on('click', '.title a, .view-details', function() {
    let id = $(this).attr("data-job-id");

      // alert('Anchor clicked!');
      history.push({
        pathname: "/jobseeker/findjobs",
        search: `?ja-job=${id}`,
      });
    });

     $(document.body).on('click', '.next', function() {
      let pageid = $(this).attr("data-page");
    const response = Axios.get(`https://apps.jobadder.com/widgets/V1/Jobs/RenderJobList?callback=jQuery19108558704436298281_1695040921642&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&jobsPerPage=10&showHotJobsOnly=false&titleIsLink=true&showDatePosted=true&datePostedFormat=%7B0%7D&dateFormat=d%2FM%2Fyyyy&showClassifications=true&classificationsToExclude=&showSalary=false&salaryFormat=%7B0%7D&includeSalaryText=false&showJobReference=false&jobReferenceFormat=%7B0%7D&alwaysShowPager=false&showPagerSummary=true&pagerGroupSize=4&scrollOnPageChange=true&animateScrollOnPageChange=false&readMoreText=More..&noJobsContent=There+are+no+jobs+matching+your+criteria.+Please+try+a+broader+search.&renderPoweredByJobAdder=false&classificationIDs=&keywords=&pageNumber=${pageid}&_=1695040921645`).then((res)=>{
      console.log("response--------------", res.data)
      setData(res.data)
    }).catch((error)=>{
      console.log(error)
    })
      return response
    });

    $(document.body).on('click', '.previous', function() {
      let pageid = $(this).attr("data-page");
    const response = Axios.get(`https://apps.jobadder.com/widgets/V1/Jobs/RenderJobList?callback=jQuery1910530798821912434_1695041908121&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&jobsPerPage=10&showHotJobsOnly=false&titleIsLink=true&showDatePosted=true&datePostedFormat=%7B0%7D&dateFormat=d%2FM%2Fyyyy&showClassifications=true&classificationsToExclude=&showSalary=false&salaryFormat=%7B0%7D&includeSalaryText=false&showJobReference=false&jobReferenceFormat=%7B0%7D&alwaysShowPager=false&showPagerSummary=true&pagerGroupSize=4&scrollOnPageChange=true&animateScrollOnPageChange=false&readMoreText=More..&noJobsContent=There+are+no+jobs+matching+your+criteria.+Please+try+a+broader+search.&renderPoweredByJobAdder=false&classificationIDs=&keywords=&pageNumber=${pageid}&_=1695041908125`).then((res)=>{
      console.log("response--------------", res.data)
      setData(res.data)
    }).catch((error)=>{
      console.log(error)
    })
      return response
    });

    $(document.body).on('click', '.ja-button', function() {
     let catId = localStorage.getItem("categoryId") ? localStorage.getItem("categoryId")  :""
     let loc = localStorage.getItem("location") ? "%2C"+localStorage.getItem("location") : ""
     let work = localStorage.getItem("work-type") ? "%2C"+localStorage.getItem("work-type")  :""
     let sub = localStorage.getItem("sub-category") ? "%2C"+localStorage.getItem("sub-category") :""
    //  console.log("location================", loc)
     console.log("category id --------------------------------------", catId)
    //https://apps.jobadder.com/widgets/V1/Jobs/RenderJobList?callback=jQuery19104529723816309019_1695009459291&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&jobsPerPage=10&showHotJobsOnly=false&titleIsLink=true&showDatePosted=true&datePostedFormat=%7B0%7D&dateFormat=d%2FM%2Fyyyy&showClassifications=true&classificationsToExclude=&showSalary=false&salaryFormat=%7B0%7D&includeSalaryText=false&showJobReference=false&jobReferenceFormat=%7B0%7D&alwaysShowPager=false&showPagerSummary=true&pagerGroupSize=4&scrollOnPageChange=true&animateScrollOnPageChange=false&readMoreText=More..&noJobsContent=There+are+no+jobs+matching+your+criteria.+Please+try+a+broader+search.&renderPoweredByJobAdder=false&classificationIDs=1554967&keywords=&pageNumber=1&_=1695009459295  
    const response = Axios.get(`https://apps.jobadder.com/widgets/V1/Jobs/RenderJobList?callback=jQuery19104529723816309019_1695009459291&key=AU5_hprrr5dgftpe3cbezcjndkmtfm&jobsPerPage=10&showHotJobsOnly=false&titleIsLink=true&showDatePosted=true&datePostedFormat=%7B0%7D&dateFormat=d%2FM%2Fyyyy&showClassifications=true&classificationsToExclude=&showSalary=false&salaryFormat=%7B0%7D&includeSalaryText=false&showJobReference=false&jobReferenceFormat=%7B0%7D&alwaysShowPager=false&showPagerSummary=true&pagerGroupSize=4&scrollOnPageChange=true&animateScrollOnPageChange=false&readMoreText=More..&noJobsContent=There+are+no+jobs+matching+your+criteria.+Please+try+a+broader+search.&renderPoweredByJobAdder=false&classificationIDs=${catId}${loc}${work}${sub}&keywords=&pageNumber=1&_=1695009459295`).then((res)=>{
      console.log("category id -------------------------------------", res.data)      
      setData(res.data)
      
    }).catch((error)=>{
      console.log(error)
    })
      return response
      });

    return () => {
      $(document.body).off('click', '.view-details');
    };

    
  }, []);

  // let d= "\u003cdiv class=\"ja-job-list-container\"\u003e \u003cdiv class=\"ja-job-list\"\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"718610\" href=\"#\" title=\"Warehouse Pick Packers\"\u003eWarehouse Pick Packers\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Melbourne \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 12/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eGreat oppurtunity for experienced and reliable pick packers (voice picking and RF scanning). Several positions available for immediate start.\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"718610\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"718539\" href=\"#\" title=\"Customer Service / Admin (warehouse and logistics)\"\u003eCustomer Service / Admin (warehouse and logistics)\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Admin / Secretarial / Office Support \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Other \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Melbourne \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 12/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eAccepting Junior admin. Knowledge of WMS (Microlistics) advantageous. Accurate data entry skills. Temp to Perm position.\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"718539\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"717800\" href=\"#\" title=\"Forklift Driver - Freezer\"\u003eForklift Driver - Freezer\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e VIC Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Contract or Temp \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 8/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eGuaranteed full time hours, available for immediate start. Cold storage environment. Attractive pay and ongoing work with the opportunity for fulltime\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"717800\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"716112\" href=\"#\" title=\"Recruitment Resourcer\"\u003eRecruitment Resourcer\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e HR \u0026 Recruitment \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Trainee Consultant \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Sydney \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Permanent / Full Time \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 1/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003e100% Outbound Phone Role Screening Job Seekers For Suitability To Place Into Contract Roles\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"716112\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"715670\" href=\"#\" title=\"Forklift Drivers - Multiple Roles - Western Suburbs\"\u003eForklift Drivers - Multiple Roles - Western Suburbs\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Sydney \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 30/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eMultiple Forklift Roles Across the western suburbs of Sydney - All Shifts Available - Full Time Casual With a View To Permanency\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"715670\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"715537\" href=\"#\" title=\"Forklift Driver - Freezer\"\u003eForklift Driver - Freezer\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e VIC Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Contract or Temp \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 30/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eGuaranteed full time hours, available for immediate start. Cold storage environment. Attractive pay and ongoing work with the opportunity for fulltime\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"715537\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"715210\" href=\"#\" title=\"Factory Hand\"\u003eFactory Hand\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Trades \u0026 Services \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Trades - Other \u003c/li\u003e \u003cli data-id=\"22986\"\u003e NSW Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 29/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eWork for a well-known Building materials logistics company, who are currently in need of Factory Hand with experience in working with aluminium metal\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"715210\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"714017\" href=\"#\" title=\"Forklift Driver\"\u003eForklift Driver\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e VIC Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 24/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eTemp to Perm position. Available for immediate start. Small team environment. Manufacturing company for construction. 40% Forklift work and 60% ground\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"714017\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003c/div\u003e \u003c/div\u003e \u003cbr /\u003e \u003cdiv class=\"powered-by-jobadder\" style=\"text-align: center\"\u003e \u003ca href=\"//jobadder.com\" target=\"_blank\" title=\"JobAdder - Recruitment Software\"\u003eJobAdder – Recruitment Software\u003c/a\u003e \u003c/div\u003e"
  
  let ab = " \u003cdiv class=\"ja-job-list-container\"\u003e \u003cdiv class=\"ja-job-list\"\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"718810\" href=\"#\" title=\"Warehouse Pick Packers - Yatala\"\u003eWarehouse Pick Packers - Yatala\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Gold Coast \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Permanent / Full Time \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 13/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eWarehouse role available for immediate start. Great hourly pay, guaranteed ongoing work and full time hours. Great team environment.\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"718810\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"718539\" href=\"#\" title=\"Customer Service / Admin (warehouse and logistics)\"\u003eCustomer Service / Admin (warehouse and logistics)\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Admin / Secretarial / Office Support \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Other \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Melbourne \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 12/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eAccepting Junior admin. Knowledge of WMS (Microlistics) advantageous. Accurate data entry skills. Temp to Perm position.\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"718539\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"718610\" href=\"#\" title=\"Warehouse Pick Packers\"\u003eWarehouse Pick Packers\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Melbourne \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 12/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eGreat oppurtunity for experienced and reliable pick packers (voice picking and RF scanning). Several positions available for immediate start.\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"718610\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"717800\" href=\"#\" title=\"Forklift Driver - Freezer\"\u003eForklift Driver - Freezer\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e VIC Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Contract or Temp \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 8/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eGuaranteed full time hours, available for immediate start. Cold storage environment. Attractive pay and ongoing work with the opportunity for fulltime\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"717800\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"716112\" href=\"#\" title=\"Recruitment Resourcer\"\u003eRecruitment Resourcer\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e HR \u0026 Recruitment \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Trainee Consultant \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Sydney \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Permanent / Full Time \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 1/9/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003e100% Outbound Phone Role Screening Job Seekers For Suitability To Place Into Contract Roles\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"716112\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"715670\" href=\"#\" title=\"Forklift Drivers - Multiple Roles - Western Suburbs\"\u003eForklift Drivers - Multiple Roles - Western Suburbs\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e Sydney \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 30/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eMultiple Forklift Roles Across the western suburbs of Sydney - All Shifts Available - Full Time Casual With a View To Permanency\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"715670\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"715537\" href=\"#\" title=\"Forklift Driver - Freezer\"\u003eForklift Driver - Freezer\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e VIC Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Contract or Temp \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 30/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eGuaranteed full time hours, available for immediate start. Cold storage environment. Attractive pay and ongoing work with the opportunity for fulltime\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"715537\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job alt\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"715210\" href=\"#\" title=\"Factory Hand\"\u003eFactory Hand\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Trades \u0026 Services \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Trades - Other \u003c/li\u003e \u003cli data-id=\"22986\"\u003e NSW Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 29/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eWork for a well-known Building materials logistics company, who are currently in need of Factory Hand with experience in working with aluminium metal\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"715210\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003cdiv class=\"job\"\u003e \u003ch2 class=\"title\"\u003e \u003ca data-job-id=\"714017\" href=\"#\" title=\"Forklift Driver\"\u003eForklift Driver\u003c/a\u003e \u003c/h2\u003e \u003cdiv class=\"meta\"\u003e \u003cul class=\"classifications\"\u003e \u003cli data-id=\"22984\"\u003e Transport / Logistics / Drivers \u003c/li\u003e \u003cli data-id=\"22985\"\u003e Warehouse \u0026 Distribution \u003c/li\u003e \u003cli data-id=\"22986\"\u003e VIC Other \u003c/li\u003e \u003cli data-id=\"22987\"\u003e Casual \u003c/li\u003e \u003c/ul\u003e \u003cp class=\"date-posted\"\u003e 24/8/2023 \u003c/p\u003e \u003c/div\u003e \u003cp class=\"summary\"\u003eTemp to Perm position. Available for immediate start. Small team environment. Manufacturing company for construction. 40% Forklift work and 60% ground\u003c/p\u003e \u003ca class=\"view-details\" data-job-id=\"714017\" href=\"#\" title=\"More..\"\u003eMore..\u003c/a\u003e \u003c/div\u003e \u003c/div\u003e \u003c/div\u003e \u003cbr /\u003e \u003cdiv class=\"powered-by-jobadder\" style=\"text-align: center\"\u003e \u003ca href=\"//jobadder.com\" target=\"_blank\" title=\"JobAdder - Recruitment Software\"\u003eJobAdder – Recruitment Software\u003c/a\u003e \u003c/div\u003e"
  // let ab = newd
  
  let text = String(data)
  let arr = text.split(" ")
  arr.shift()
  let item = arr.join(" ")
  let newitem = unescape(JSON.parse(`"${item.slice(0, -3)}"`));
  // const val = data.toString()
  // const newitem = val.slice(0, -3)
  // const newval = newitem.slice(44)
  // let netitem2 = "<div>"+newitem.replace(/\\/g, '')+"<div>";
  // console.log("***************######################**********",newitem);



    return (
      <>
      
        {/* <div className={style.job_body}>
          <div className={style.ja_form}>
            <div className={style.ja_field_container}>
              <label for="ja-def-22984"> Category </label>
              <div className={style.ja_field}>
                <select id="ja-def-22984" data-child="ja-def-22985">
                  <option value="0">Category</option>
                  <option value="1554967">HR &amp; Recruitment</option>
                  <option value="1554977">Sales &amp; Account Management</option>
                  <option value="1554980">Trades &amp; Services</option>
                  <option value="1554981">Transport / Logistics / Drivers</option>
                </select>
              </div>
            </div>
            <div className={style.ja_field_container}>
              <label for="ja-def-22985"> Sub Category </label>
              <div className={style.ja_field}>
                <select id="ja-def-22985">
                  <option value="0">Sub Category</option>
                </select>
              </div>
            </div>
            <div className={style.ja_field_container}>
              <label for="ja-def-22986"> Location </label>
              <div className={style.ja_field}>
                <select id="ja-def-22986" data-child="ja-def-0">
                  <option value="0">Location</option>
                  <option value="1555459">Sydney</option>
                  <option value="1555460">NSW Other</option>
                  <option value="1555462">VIC Other</option>
                  <option value="1555463">Brisbane</option>
                </select>
              </div>
            </div>
            <div className={style.ja_field_container}>
              <label for="ja-def-22987"> Work Type </label>
              <div className={style.ja_field}>
                <select id="ja-def-22987" data-child="ja-def-0">
                  <option value="0">Work Type</option>
                  <option value="1555474">Permanent / Full Time</option>
                  <option value="1555475">Contract or Temp</option>
                  <option value="1555477">Casual</option>
                </select>
              </div>
            </div>
            <div className={style.ja_field_container}>
              <label for="ja-keywords">Keywords</label>
              <div className={style.ja_field}>
                <input id="ja-keywords" type="text" maxlength="50"
                 value={searchInput} name="searchInput"  onChange={(e) => handleChange(e)}/>
              </div>
            </div>
            <div className={style.ja_submit}>
              <input
                type="button"
                className={style.ja_button}
                value="Search"
                title="Search/"
                onClick={(e)=>handleSearchData(e)}
              />
            </div>
          </div>
        </div> */}
        <div dangerouslySetInnerHTML={{ __html: snewitem }}/>

        <div dangerouslySetInnerHTML={{ __html: newitem }}/>
        

        {/* <div className={style.ja_job_list_container}>
          <div className={style.ja_job_list}>
            {searchInput?.length > 0 ?
              filteredResults.map((item,i)=>{
                return (
                  <>
                   <div className={style.job} key={i}>
              <h2 className={style.title}>
                <a data-job-id="717800" href="#" title="Forklift Driver - Freezer">
                  {item.heading}
                </a>
              </h2>
              <div className={style.meta}>
               {
                item.classification.map((data,i)=>{
                  return(
                    <ul className={style.classifications}>
                    <li data-id="22984">{data.list1}</li>
                    <li data-id="22985">{data.list2} </li>
                    <li data-id="22986">{data.list3}</li>
                    <li data-id="22987">{data.list4} </li>
                  </ul>
                  )
                })
               }
                <p className={style.date_posted}> {item.date}</p>
              </div>
              <p className={style.summary}>
               {item.summery}
              </p> 
              <button      
                onClick={()=>handleButtonClick(item.id)}
                className={style.view_details}>
                {item.more}
              </button>
            </div>
                  </>
                )
              }) : 
              jobData.map((item,i)=>{
                return (
                  <>
                   <div className={style.job} key={i}>
              <h2 className={style.title}>
                <a data-job-id="717800" href="#" title="Forklift Driver - Freezer">
                  {item.heading}
                </a>
              </h2>
              <div className={style.meta}>
               {
                item.classification.map((data,i)=>{
                  return(
                    <ul className={style.classifications}>
                    <li data-id="22984">{data.list1}</li>
                    <li data-id="22985">{data.list2} </li>
                    <li data-id="22986">{data.list3}</li>
                    <li data-id="22987">{data.list4} </li>
                  </ul>
                  )
                })
               }
                <p className={style.date_posted}> {item.date}</p>
              </div>
              <p className={style.summary}>
               {item.summery}
              </p> 
              <button      
                onClick={()=>handleButtonClick(item.id)}
                className={style.view_details}>
                {item.more}
              </button>
            </div>
                  </>
                )
              })
            }
           
          </div>
        </div> */}

        {/* <div className={style.powered_by_jobadder} style={{textAlign: "center"}}>
          
          <a
            href="//jobadder.com"
            target="_blank"
            title="JobAdder - Recruitment Software">
            JobAdder – Recruitment Software
          </a>
        </div> */}

        {/* <iframe className="submitcv_iframe"  src="https://whitecollarblue.vincere.io/careers/" width="950px" height="2650px"></iframe> */}
      </>
    );
  }

export default withRouter(JobDetails);
  // applySuccess() {
  //   App.Current.AlertSuccess("We'll contact you soon.");
  // }

  // getJobContent() {
  //   const job = this.state.job;
  
  //   return (
  //     <>
  //       <article>
  //         <div className={`body__article--padding ${style.jobDetails}`}>
  //           <h4>{job.title}</h4>
  //           {job.description && (
  //             <div dangerouslySetInnerHTML={{__html: job.description}} />
  //           )}
  //         </div>
  //         <div className={style.jobDetails_apply}>
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             size="large"
  //             className="custom-button"
  //             onClick={this.handleApplyNowOpen}>
  //             Apply Now
  //           </Button>
  //         </div>
  //       </article>
  //       <aside>
  //         <div className={style.actions}>
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             size="large"
  //             className="custom-button"
  //             onClick={this.handleApplyNowOpen}>
  //             Apply Now
  //           </Button>
  //           <Button
  //             variant="outlined"
  //             color="primary"
  //             size="large"
  //             className="custom-button"
  //             style={{background: "white"}}
  //             onClick={() => App.Current.Navigate("/jobseeker/board")}>
  //             Back to job list
  //           </Button>
  //         </div>
  //         <JobOverview job={job} />
  //       </aside>
  //     </>
  //   );
  // }

  // componentDidMount() {
  //   ScrollToTop();
  //   this.getJobInfo();
  // }

  // componentDidUpdate() {
  //   ScrollToTop();
  //   const currentId = this.getJobId();
  //   if (currentId != this.state.id) {
  //     if (this.state.id) {
  //       this.setState({
  //         id: currentId,
  //       });
  //     }

  //     // Prevent Loop.
  //     if (this.state.found) {
  //       this.getJobInfo();
  //     }
  //   }
  // }

  // getJobId() {
  //   let id = null;

  //   // Look at the Address.
  //   const addressParts = SplitNonEmpty(window.location.pathname, "/");
  //   // Address has ID.
  //   if (addressParts.length == 3) {
  //     id = addressParts[2];
  //   }

  //   return id;
  // }

  /**
   * Gets the Job Information.
   */
  // getJobInfo() {
  //   const id = this.getJobId();

  //   // Populate model with Step data if an ID exists.
  //   if (id) {
  //     App.Current.API.Jobs.GetJob(id)
  //       .then((job) => {
  //         // Set Page Metadata
  //         try {
  //           App.Current.SetPageName(job.title);
  //           Metadata("og:type", "article");
  //           //Metadata("description", job.summary);
  //           //Metadata("og:description", job.summary);
  //           Metadata(
  //             "og:url",
  //             `https://whitecollarblue.com.au/jobseeker/board/${job.id}`
  //           );
  //         } catch (e) {
  //           console.log(e);
  //         }

  //         // Set State.
  //         this.setState({job: job, id: id});
  //       })
  //       .catch((e) => this.setState({found: false}));
  //   }
  // }

  // handleApplyNowOpen = () => {
  //   this.setState({applyNowOpen: true});
  // };

  // handleClose = () => {
  //   this.setState({applyNowOpen: false});
  // };

  // onApplyNowModalFormSubmit = () => {
  //   this.setState({applyNowOpen: false});
  // };

  // componentWillUnmount() {
  //   App.Current.SetPageName(null);
  // }


// const JobOverview = (props) => {
//   const job = props.job;
//   const address = job.address;
//   const categories = job.categories
//     .filter((c) => !isNullOrUndefined(c))
//     .map((c) => c.name)
//     .join(", ");
//   const skills = job.skills
//     .filter((s) => !isNullOrUndefined(s))
//     .map((s) => s.name)
//     .join(", ");

//   return (
//     <div className={style.overview}>
//       {(categories || skills) && (
//         <div>
//           <span>
//             {categories && <b>{categories}</b>}
//             {skills && (
//               <>
//                 &nbsp;
//                 <IoIosArrowForward />
//                 &nbsp;{skills}
//               </>
//             )}
//           </span>
//         </div>
//       )}

//       {address && (
//         <div>
//           <span>
//             {address.country && (
//               <>
//                 <b>{address.country}</b>
//                 &nbsp;
//                 <IoIosArrowForward />
//                 &nbsp;
//               </>
//             )}
//             {address.region && (
//               <>
//                 <b>{address.region}</b>
//                 &nbsp;
//                 <IoIosArrowForward />
//                 &nbsp;
//               </>
//             )}
//             {address.locality && (
//               <>
//                 {address.locality}
//                 &nbsp;
//               </>
//             )}
//           </span>
//         </div>
//       )}

//       {job.type && (
//         <div>
//           <span>
//             <b>{job.type}</b>
//           </span>
//         </div>
//       )}

//       <hr />
//       <div className={style.overview__moreDetail}>
//         {job.bullhornID && (
//           <div>
//             <b>Job ID</b>
//             <span>{job.bullhornID}</span>
//           </div>
//         )}
//         {job.duration && (
//           <div>
//             <b>Duration</b>
//             <span>{job.durationWeeks} Weeks</span>
//           </div>
//         )}
//         {job.openings && (
//           <div>
//             <b>Positions Available</b>
//             <span>{job.openings}</span>
//           </div>
//         )}
//         {job.startDate && (
//           <div>
//             <b>Start Date</b>
//             <span>{formatDate(job.startDate)}</span>
//           </div>
//         )}
//       </div>

//       <hr />

//       <div className={style.overview__moreDetail}>
//         <div>
//           <b>Date Added</b>
//           <span>{formatDate(job.created)}</span>
//         </div>
//       </div>
//     </div>
//   );
// };
